import * as React from 'react';

class TableToolbar extends React.Component {
    public render() {
        return (
            <div className="float-right button-group">
                {this.props.children}
            </div>
        );
    }
}

export default TableToolbar;